<!--
  v1 格式通知渲染（version 缺省）
  已冻结：messageType 枚举见 message.ts，不再新增场景
-->
<script lang="ts" setup>
import type { UserMessageVo } from '@core/types/auto/forum';
import { MessageType } from '@core/utils/message';

defineProps<{ item: UserMessageVo }>();
</script>

<template>
  <div class="break-words font-semibold">
    <span>{{ item.messageContent }}</span>
    <span v-if="item.messageType === MessageType.USER_REPLY" class="ml-1"
      >回复了你</span
    >
  </div>
  <a-tooltip :title="item.posterName ?? ''">
    <div class="text-subtitle truncate">
      <span
        v-if="item.messageType === MessageType.AWARD_VERIFYING"
        class="text-font1 mr-1 font-bold"
        >[认证中]</span
      >
      <span
        v-else-if="item.messageType === MessageType.AWARD_APPROVED"
        class="text-success mr-1 font-bold"
        >[认证通过]</span
      >
      <span
        v-else-if="item.messageType === MessageType.AWARD_REJECTED"
        class="text-error mr-1 font-bold"
        >[认证失败]</span
      >
      <span class="text-font2">{{ item.posterName }}</span>
    </div>
  </a-tooltip>
</template>
